<template>
  <div
    v-if="dataLoaded">
    <d-card :class="{
      'order-creator-summary': true,
      'mt-5': true,
      'text-right': true,
      'is-visible': isVisible
    }">
      <d-card-body class="px-1 px-md-2 px-lg-3 py-2 py-md-3 py-lg-4">
        <h5>Podsumowanie:</h5>
        <hr>

        <table class="ml-auto">
          <tr>
            <td class="pr-5">Koszt produktów: </td>
            <td>{{ roundProperly(productsCost) }} zł</td>
          </tr>
          <tr v-if="productsCost !== productsWithoutDiscountCost">
            <td class="pr-5">Bez rabatu: </td>
            <td><del class="text-danger">{{ roundProperly(productsWithoutDiscountCost) }} zł</del></td>
          <tr>
          <tr>
            <td class="pr-5">Podatek VAT: </td>
            <td>{{ roundProperly(vatSum) }} zł</td>
          </tr>
          <tr>
            <td class="pr-5">Dostawa: </td>
            <td>{{ roundProperly(shippingCost) }} zł</td>
          </tr>
          <tr>
            <td class="pr-5">RAZEM:</td>
            <td>
              <span class="text-primary">
                {{ roundProperly(totalCost) }} zł
              </span>
            </td>
          </tr>
        </table>
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
import Vue from 'vue';
import CustomDecimals from '@/utils/CustomDecimals.js';

export default {
  name: 'order-creator-summary',
  props: [
    'isVisible',
    'orderProducts',
    'productDefaultPricesAndTaxes'
  ],
  computed: {
    productsCost () {
      let currentProductCost = this.orderProducts.filter(product => product.product_id).reduce((sum, product) => {
        let prodQuantity = product.quantity || 0;
        return sum + (parseFloat(product.price) * parseInt(prodQuantity, 10));
      }, 0);

      if ((currentProductCost - this.vatSum) > 300) {
        Vue.set(this, 'shippingCost', 0);
      } else {
        Vue.set(this, 'shippingCost', this.baseShippingCost);
      }
      return currentProductCost;
    },
    productsWithoutDiscountCost () {
      return this.orderProducts.filter(product => product.product_id).reduce((sum, product) => {
        let prodQuantity = product.quantity || 0;
        return sum + (parseFloat(product.price_before_discount) * parseInt(prodQuantity, 10));
      }, 0);
    },
    vatSum () {
      return this.orderProducts.filter(product => product.product_id).reduce((sum, product) => {
        let keyToUse = product.variant_product_id ? 'variant_product_id' : 'product_id';
        let productKey = parseInt(product[keyToUse], 10);

        if (!this.productDefaultPricesAndTaxes[productKey]) {
          return sum;
        }

        let prodQuantity = product.quantity || 0;
        let vatRate = this.productDefaultPricesAndTaxes[productKey].vatRate;
        let vatQuote = parseFloat(this.roundProperly(product.price - (product.price * (100 / (100 + vatRate)))) * parseInt(prodQuantity, 10));
        return sum + parseFloat(vatQuote);
      }, 0);
    },
    totalCost () {
      return parseFloat(this.productsCost) + parseFloat(this.shippingCost);
    }
  },
  data () {
    return {
      baseShippingCost: 0,
      shippingCost: 0,
      dataLoaded: false
    };
  },
  mounted () {
    this.$bus.$on('order-update-shipment-cost', this.updateShippingCost);
    this.$bus.$on('order-products-all-loaded', this.setDataLoaded);
  },
  methods: {
    updateShippingCost (newShippingCost) {
      Vue.set(this, 'baseShippingCost', newShippingCost);

      if ((this.productsCost - this.vatSum) > 300) {
        Vue.set(this, 'shippingCost', 0);
      } else {
        Vue.set(this, 'shippingCost', newShippingCost);
      }
    },
    setDataLoaded () {
      this.dataLoaded = true;
    },
    roundProperly (value, decimals = 2) {
      return CustomDecimals.roundProperly(value, decimals);
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-update-shipment-cost', this.updateShippingCost);
    this.$bus.$off('order-products-all-loaded', this.setDataLoaded);
  }
};
</script>

<style lang="scss" scoped>
.order-creator-summary {
  display: none;

  &.is-visible {
    display: block;
  }
}
</style>
